import { DatastoreInterface } from '@freelancer/datastore/core';
import { Project } from '../projects/projects.model';
import { UserRecentProjectsAndContestsEntry } from './user-recent-projects-and-contests.model';
import { UserRecentProjectsAndContestsCollection } from './user-recent-projects-and-contests.types';

interface GenerateRecentProjectsAndContestsOptions {
  readonly projects: ReadonlyArray<Project>;
}

export async function createRecentProjectsAndContests(
  datastore: DatastoreInterface,
  options: GenerateRecentProjectsAndContestsOptions,
) {
  const objects = generateRecentProjectsAndContestsObjects(options);
  await Promise.all(
    objects.map(object =>
      datastore.createRawDocument<UserRecentProjectsAndContestsCollection>(
        'userRecentProjectsAndContests',
        object,
      ),
    ),
  );

  return objects;
}

function generateRecentProjectsAndContestsObjects({
  projects,
}: GenerateRecentProjectsAndContestsOptions): ReadonlyArray<
  UserRecentProjectsAndContestsEntry
> {
  return projects.map(({ id, title, seoUrl, timeSubmitted }) => ({
    id: `project-${id}`,
    type: 'project',
    latest: timeSubmitted,
    name: title,
    projectOrContestId: id,
    urlPart: `/projects/${seoUrl}`,
  }));
}
